import { useEffect } from "react";
import { redirect, Outlet, useParams } from "react-router";
import { useLocaleStore } from "~/stores/locale";
import { NON_ENGLISH_LOCALES } from "~/lib/locales";
import type { Route } from "./+types/locale-layout";

type SupportedLocale = (typeof NON_ENGLISH_LOCALES)[number];

export function loader({ params }: Route.LoaderArgs) {
  if (!NON_ENGLISH_LOCALES.includes(params.locale as SupportedLocale)) {
    return redirect("/");
  }
  return null;
}

export default function LocaleLayout() {
  const { locale } = useParams();
  const setLocale = useLocaleStore((s) => s.setLocale);

  useEffect(() => {
    if (locale) {
      setLocale(locale);
    }
    // Reset to English when navigating back to the root route
    return () => setLocale("en");
  }, [locale, setLocale]);

  return <Outlet />;
}
